export default function SelectedGenreBtn(props){
    return(
        <div className="genre-btn">
            {props.genre}
        </div>
    )
}